import { render, staticRenderFns } from "./configStudent.vue?vue&type=template&id=593e7f05"
import script from "./configStudent.vue?vue&type=script&lang=js"
export * from "./configStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports